import React, { useEffect, useState } from 'react'
import View from '@modul-connect/shared/components/atoms/view'
import Button from '@modul-connect/shared/components/atoms/button'
import { H1, Span } from '@modul-connect/shared/components/atoms/text'
import modal from '@modul-connect/shared/components/atoms/modal'
import theme from '@modul-connect/shared/theme'
import { Fade, Modal } from '@mui/material'
import { DateControl } from './dateControl'
import { TimeControl } from './timeControl'
import { TimeZoneControl } from './timeZoneControl'
import { DurationControl } from './durationControl'


export const FlightModeForm = ({ flightModeCommand, onSave, onCancel, show }) => {
  const [command, setCommand] = useState(flightModeCommand)
  const disabled = false

  useEffect(() => {
    setCommand(flightModeCommand)
  }, [flightModeCommand])

  if(!command)
    return null

  return (
    <Modal
      open={ show }
      onClose={(event, reason) => {
        if (disabled && reason === 'backdropClick') {
          return
        }
        onCancel()
      }}            
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
    >
      <Fade in={ show }>
        <div>
          <View extend={ modal.container }>
            <View extend={ modal.header }>
              <H1 text="Add new scheduled flight mode" />
            </View>
            <View extend={ modal.content }>
              <View>
                <Span extend={ [styles.span ] }>Time zone of departure:</Span>
                <TimeZoneControl value={command.timezone} onChange={e => setCommand(c => ({ ...c, timezone: e }))} />
              </View>
              <View>
                <Span extend={ [styles.span ] }>Turn on flight mode:</Span>
                <DateControl value={command.date} onChange={e => setCommand(c => ({ ...c, date: e }))} />
              </View>
              <View>
                <Span extend={ [styles.span ] }>Time (local):</Span>
                <TimeControl value={command.time} onChange={e => setCommand(c => ({ ...c, time: e }))} />
              </View>
              <View>
                <Span extend={ [styles.span ] }>Duration:</Span>
                <DurationControl value={command.duration} onChange={e => setCommand(c => ({ ...c, duration: parseInt(e) }))} />
              </View>
            </View>
            <View extend={ modal.footer }>
              <Button noBg disabled={ disabled } cancel onClick={onCancel}>
                          Cancel
              </Button>
              <Button noBg disabled={ disabled } noPadding onClick={() => onSave(command) }>
                          Submit
              </Button>
            </View>
          </View>
        </div>
      </Fade>
    </Modal>
  )
}


const styles = {
  span: {
    fontSize: 12,
    marginLeft: 3,
    color: theme.colors.darkGrey
  },
}
